import { render, staticRenderFns } from "./ModalTipoListaPrecio.vue?vue&type=template&id=65856ecb"
import script from "./ModalTipoListaPrecio.vue?vue&type=script&lang=js"
export * from "./ModalTipoListaPrecio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports